export default {
    date: "{{date, DD-MM-YYYY}}",
    // dateFormat: "{{date, DD/MM/YYYY HH:mm}}",
    dateTime: "{{date, DD//MM/YYYY HH:mm}}",
};
